import { ILineStyle, ILineDrawable } from "../../../../../../../base/domain/drawing";
import { IObjectBeanShapedLineDrawable } from "../../../beans/objects";
import { IntegerTranslator, ColorCodeTranslator } from "../../values";

export class LineStyleTranslator {
  from(bean: IObjectBeanShapedLineDrawable): ILineStyle {
    return {
      kind: this.integer.from(bean["@type"]),
      color: {
        value: this.colorCode.from(bean["@color"]),
      },
      width: this.integer.from(bean["@border-width"]),
      opacity: 1,
    };
  }

  to(object: ILineDrawable) {
    return {
      type: this.integer.to(object.lineStyle.kind),
      color: this.colorCode.to(object.lineStyle.color.value),
      borderWidth: this.integer.to(object.lineStyle.width),
    };
  }
 
  private readonly integer = new IntegerTranslator();
  private readonly colorCode = new ColorCodeTranslator();
}
